import axios from '../../axios'

export default {
	state: {
		messagesAuthor: {},
		statusAuthor: 'ready',// loading,ready,error
		displayAuthor: false,
		payloadAuthor: {},
		idChatAuthor: 0,
		is_chat_unread: false,
		collocutorAuthor: {},
	},
	mutations: {
		updatepayloadAuthor(state, payloadAuthor) {
			state.payloadAuthor = payloadAuthor;
		},
		updateMessagesAuthor(state, messages) {
			state.statusAuthor = 'ready';
			state.messagesAuthor = messages;
		},
		updateIsChatUnread(state, is_chat_unread) {
			state.is_chat_unread = is_chat_unread;
		},
		addMessageAuthor(state, message) {
			state.messagesAuthor.unshift(message);
		},
		messageRequestAuthor(state) {
			state.statusAuthor = 'loading'
		},
		errorAuthor(state) {
			state.statusAuthor = 'error';
		},
		showChatAuthor(state) {
			if(state.displayAuthor !== true) {
				state.displayAuthor = true;
			}
		},
		setidChatAuthor(state,id) {
			state.idChatAuthor = id
		},
		hideChatAuthor(state) {
			state.status = 'close';
			state.displayAuthor = false;
		},
		updatecollocutorAuthor(state, payloadAuthor) {
			state.collocutorAuthor = payloadAuthor;
		}
	},
	actions: {
		async getMessagesAuthor({state, commit},payloadAuthor = null) {
			commit('messageRequestAuthor');

			if(payloadAuthor !== null) {
				let id;

				if(payloadAuthor && payloadAuthor.id){
					id = (await axios.post('/chat-author/create',{order_id:+payloadAuthor.id})).data.data.id;
				}
				else if(payloadAuthor && payloadAuthor.userId){
					const res = (await axios.post('/chat-author/create',{user_id:+payloadAuthor.userId})).data.data;
					id = res.id;

					let clientData = res.client_data;
					clientData.role = "client";

					commit("updatecollocutorAuthor", clientData);
				}
				else{
					id = (await axios.post('/chat-author/create')).data.data.id;
					let clientData = { role: "manager" };
					commit("updatecollocutorAuthor", clientData);
				}

				commit("setidChatAuthor", id);

				commit('showChatAuthor');
			}

			if(payloadAuthor === null) {
				if(state.displayAuthor !== false) {
					payloadAuthor = state.payloadAuthor;
				} else {
					return;
				}
			} else {
				commit("updatepayloadAuthor", payloadAuthor);
			}
			let id = state.idChatAuthor;

			if (!id) return false;

			await axios.post(`/chat-author/set-messages-viewed/${id}`);

			commit('setidChatAuthor',id)
			return new Promise((resolve,reject)=>{
				axios.get('/chat-author/view/'+id)
					.then(resp=>{
					commit('updateMessagesAuthor', resp.data.data);
					commit('updateIsChatUnread', resp.data.is_chat_unread);

					resolve(resp);
				}).catch(err => {
					commit('errorAuthor')
					reject(err);
				})
			})
		},
		hideChatAuthor({commit}) {
			commit('hideChatAuthor');
		},
		async sendMessageAuthor({commit,state,dispatch}, message) {
			commit('messageRequestAuthor');
			if(!state.idChatAuthor) return false;
			return new Promise((resolve, reject) => {
				axios.post('/chat-author/send-message/'+state.idChatAuthor,{message: message.msg})
					.then(async resp => {
						resolve(resp);
					})
					.catch(err => {
						commit('errorAuthor')
						reject(err);
					})
			})
		}
	},
	getters: {}
}
